export default "__VITE_ASSET__b177985f__"